import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const validateAddressForCardMigrationActions = createDataModuleActions(
    'VALIDATE_ADDRESS_FOR_CARD_MIGRATION',
);
export const validateAddressForCardMigration =
    validateAddressForCardMigrationActions.dataRequest;
export const validateAddressSuccessForCardMigration =
    validateAddressForCardMigrationActions.dataSuccess;
export const validateAddressErrorForCardMigration =
    validateAddressForCardMigrationActions.dataError;
export const validateAddressResetForCardMigration =
    validateAddressForCardMigrationActions.dataReset;
